module.exports = __webpack_public_path__ + "img/ck-jl.6b896195.png";